import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/style.scss';
import './theme.css';
import './staticBranding.css';
import { applyBuildTimeBrandingFlags } from './brandingFlags';

applyBuildTimeBrandingFlags();

const App = require('./app').default;

ReactDOM.render(<App />, document.getElementById('root'));